import React from "react";
import {  Box, IconButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { catchElement, elementToBase64 } from "./defineUtils";
import { exportFile, setState } from "./defineSlice";

const ExportData = (props) => {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      selectedQuota,
      selectedCountry,
      selectedScenario,
      selectedPeriod,
      selectedProduct,
      selectedDepletion,
      quotaChartColumns,
      graphTableData,
      quotaChartData,
      gridDataChanged,
      showChart,
      gridData
   } = define;

   function handleExport(isPdf) {
      if(gridDataChanged) {
         dispatch(setState("exportPdf", isPdf));
         dispatch(setState("exportDataModalOpen", true));
      }
      else {
         exportDataAsFile(isPdf);
      }
   }

   async function exportDataAsFile(isPdf) {
      let quotaCustomers = [];
      if(selectedQuota.listQuotaCustomers.length > 0) {
         quotaCustomers = selectedQuota.listQuotaCustomers.slice();
      }
      else {
         let array = JSON.parse(JSON.stringify(selectedQuota.listQuotaCustomers2));
         let joinedArray = array.map(item1 => {
            let item2 = gridData.find(item => item.skuid === item1.skuid && item.customerID === item1.customerID
               && item.customerGroupID === item1.customerGroupID && item.productGroupID === item1.productGroupID);
            return { ...item1, name: item2.name, packName: item2.packName, skuNumb: item2.skuNumb, customerNumber: item2.customerNumber };
        });
        quotaCustomers = joinedArray;
      }
      const list = quotaCustomers.map((item) => {
         return {
            adjustment: item.adjustment,
            customerGroupID: item.customerGroupID,
            customerNumber: item.customerNumber,
            customerQuotaComments: item.customerQuotaComments,
            initialQuota: item.initialQuota,
            name: item.name,
            packName: item.packName,
            quota: item.quota,
            safetyMargin: item.safetyMargin,
            skuNumb: item.skuNumb,
            unusedQuota: item.unusedQuota,
            weekly1: item.weekly1,
            weekly2: item.weekly2,
            weekly3: item.weekly3,
            weekly4: item.weekly4,
            weekly5: item.weekly5,
            tender: item.tender,
            isBuffer: item.isBuffer,
            sit: item.sit,
         };
      });

      const elem = catchElement(".DefineQuotaChart");
      const elemBase64 = await elementToBase64(elem);

      const graphTableData = quotaChartData.map((item) => {
         return item[0];
      });

      let payload = {
         countryId: selectedCountry.countryID,
         countryName: selectedCountry.countryName,
         displayDate: selectedPeriod.displayDate,
         effectiveEndDate: selectedPeriod.endDate,
         effectiveStartDate: selectedPeriod.startDate,
         isWeekly: selectedDepletion.value.includes("weekly"),
         scenarioID: selectedScenario.scenarioID,
         scenarioName: selectedScenario.scenarioName,
         selectedProduct: selectedProduct.packGroupOrSKUName,
         listQuotaCustomers3: list,
         chartImage: elemBase64,
         depletionType: selectedDepletion.key
         // graphTableCol: quotaChartColumns.slice(1),
         // graphTableData: graphTableData,
      };

      if(showChart === false) {
         let chartCols = quotaChartColumns.slice();
         let graphTableCol = ["Data"];
         for(let i = 0; i < graphTableData.length; ++i) {
            let item = graphTableData[i];
            graphTableCol.push(item.split(",")[0]);
         }

         if(chartCols[0] === "Series") {
            chartCols.shift();
         }

         let graphTableColList = [];
         for(let i = 0; i < graphTableData.length; ++i) {
            let list = graphTableData[i].split(",");
            list = list.slice(1);
            list = list.map(item => item === "null" ? "" : item);
            graphTableColList.push(list);
         }
         let graphTableData_ = [];
         for(let i = 0; i < chartCols.length; ++i) {
            let list = [chartCols[i]];

            for(let j = 0; j < graphTableColList.length; ++j) {
               list.push(graphTableColList[j][i]);
            }
            graphTableData_.push(list);
         }
         console.log("graphTableCol", graphTableCol);
         console.log("graphTableData", graphTableData_);

         payload = {
            ...payload,
            graphTableCol,
            graphTableData: graphTableData_
         };
      }

      const obj = {
         isPdf, payload, displayType: showChart ? "graph" : "table"
      }

      console.log("Define_ExportData_exportDataAsFile", obj);
      dispatch(exportFile(obj));
   }

   return (
      <Box className="imageDiv">
         <Box
            sx={{
               display: "flex",
               flexDirection: "row",
               justifyContent: "flex-start",
            }}
         >
            <IconButton onClick={(e) => handleExport(false)}>
               <GridOnIcon sx={{ color: "green.main" }} />
            </IconButton>
            <IconButton onClick={(e) => handleExport(true)}>
               <PictureAsPdfIcon sx={{ color: "red.main" }} />
            </IconButton>
         </Box>
      </Box>
   );
};

export default ExportData;
